import Vue from "vue";
import vueDirectiveTooltip from "vue-directive-tooltip";
import vueAwesomeSwiper from "vue-awesome-swiper";
import vModal from "vue-js-modal"
import HouseModel from "./houseModel";
import Store from "./store/index";

const vueHouseModel = {
    init: function (dbState, dictionaries) {
        Vue.use(vueDirectiveTooltip);
        Vue.use(vueAwesomeSwiper);
        Vue.use(vModal);

        // ReSharper disable once UnusedLocals
        const app = new Vue({
            el: "#app",
            store: Store,
            template: '<HouseModel />',
            components: { HouseModel },
            created: function () {
                this.$store.commit("initFromDb", dbState);
                this.$store.commit("setApartmentSizes", dictionaries.apartmentSizes);
                this.$store.commit("setSupplierAddresses", dictionaries.supplierAddresses);
            },
        });

    }
};

// expose vue app to global scope as window.vueHouseModel
global.vueHouseModel = vueHouseModel;



// WEBPACK FOOTER //
// ./assets/vue/houseModel/main.js